import { styled } from '@mui/material';

export const PageW = styled('div')`
  padding-left: 38px;
  padding-top: 64px;
  justify-content: center;

  @media (max-width: 1023px) {
    padding: 88px 16px 80px 16px;
  }
`;
